import { isDropshippingFlow, ProductUtils } from '@wix/package-picker-shared';
import { usePersonalizedFeatures } from '@wix/package-picker-shared-eclipse';
import { ProductCardList } from '@wix/premium-purchase-platform/@components';
import React from 'react';
import { ProductCard } from './ProductCard/ProductCard';
import { ProductCardsSkeleton } from './ProductCardsSkeleton';

export const ProductCards = () => {
  const isDropshippingIntent = isDropshippingFlow();
  // Rendering the product's own list first and swapping it a second later is
  // the flash this gate exists to prevent. Covers the params window too, and
  // only ever holds for the treatment arm.
  const { isLoading: isPersonalizedFeaturesLoading } =
    usePersonalizedFeatures();

  // Same skeleton the list's own loader renders — only a longer hold.
  if (isPersonalizedFeaturesLoading) {
    return <ProductCardsSkeleton numCards={isDropshippingIntent ? 3 : 4} />;
  }

  return (
    <ProductCardList.Default.Root
      gap={12}
      useLoader={() => (
        <ProductCardsSkeleton numCards={isDropshippingIntent ? 3 : 4} />
      )}
      width="100%"
    >
      {({ products }) => {
        const sortedProducts = ProductUtils.sortProducts({ products });

        return sortedProducts.map((product, cardIndex) => {
          if (!product.productId) {
            return null;
          }

          return (
            <ProductCard
              key={product.productId}
              productId={product.productId}
              cardIndex={cardIndex}
              cardCount={sortedProducts.length}
            />
          );
        });
      }}
    </ProductCardList.Default.Root>
  );
};
